const createMockFunction = () =>
  typeof jest !== 'undefined'
    ? jest.fn().mockImplementation(() => Promise.resolve({}))
    : () => Promise.resolve({});

export const mockConceptFeedbackApi = {
  getAll: createMockFunction(),
  get: createMockFunction(),
  create: createMockFunction(),
  update: createMockFunction(),
  remove: createMockFunction(),
}
